import React from 'react';
import { tourManager } from '../../utils/TourManager';

// ChatSidebar analysis controls component showing tour progress and dev controls
// Extracted from ChatSidebar.jsx lines 982-1040
const ChatAnalysisControls = ({ tourInProgress, setTourInProgress, darkMode }) => {
  return (
    <>
      {/* Subtle Analysis Controls */}
      {tourInProgress && (
        <div className={`
          p-2 border-t flex items-center justify-between
          ${darkMode ? 'border-gray-700 bg-gray-800/50' : 'border-gray-200 bg-blue-50/50'}
        `}>
          <div className="flex items-center gap-2 text-xs">
            <span>🧠</span>
            <span className={`font-medium ${darkMode ? 'text-gray-300' : 'text-blue-700'}`}>
              Running analysis
            </span>
            <div className="flex space-x-1">
              <div className="w-1 h-1 bg-current rounded-full animate-pulse"></div>
              <div className="w-1 h-1 bg-current rounded-full animate-pulse" style={{animationDelay: '0.2s'}}></div>
              <div className="w-1 h-1 bg-current rounded-full animate-pulse" style={{animationDelay: '0.4s'}}></div>
            </div>
          </div>
          <button
            onClick={() => {
              tourManager.stopTour();
              setTourInProgress(false);
            }}
            className={`
              text-xs px-2 py-1 rounded transition-colors
              ${darkMode 
                ? 'text-gray-400 hover:text-gray-200 hover:bg-gray-700' 
                : 'text-gray-500 hover:text-gray-700 hover:bg-gray-100'
              }
            `}
          >
            Stop
          </button>
        </div>
      )}
    </>
  );
};

export default ChatAnalysisControls;
